import type { NotificationRepository } from '../../repositories/ApiNotificationRepository';

export class NotificationService {
  constructor(private readonly repo: NotificationRepository) {}

  getPreferences() {
    return this.repo.getPreferences();
  }

  setAll(params: Parameters<NotificationRepository['setAll']>[0]) {
    return this.repo.setAll(params);
  }

  setCategory(params: Parameters<NotificationRepository['setCategory']>[0]) {
    return this.repo.setCategory(params);
  }

  setType(params: Parameters<NotificationRepository['setType']>[0]) {
    return this.repo.setType(params);
  }
}
